var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.05357,
    height: 13,
    viewBox: "0 0 9.05357 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33929 0L0 7.19643H3.71429L3.25 13L9.05357 5.10714H5.10714L5.33929 0Z",
    fill: "#CA4CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkGlyph);
export default __webpack_public_path__ + "static/media/spark-glyph.3a23c9e3091c48c80230b8d45a0cd6e7.svg";
export { ForwardRef as ReactComponent };